var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, useMediaQuery, useTheme } from '@mui/material';
import { Slider } from 'hx-ui';
import { useAudioPlayerContext } from 'hx-audio-player';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BsVolumeOff, BsVolumeUp } from 'react-icons/bs';
export function VolumeSelectContent() {
    var theme = useTheme();
    var _a = useFormContext(), getValues = _a.getValues, setValue = _a.setValue;
    var selectedVolume = getValues('volume');
    var setVolume = useAudioPlayerContext().setVolume;
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    useEffect(function () {
        if (!selectedVolume) {
            setVolume(0.1);
            return;
        }
        setVolume(selectedVolume / 100);
    }, [selectedVolume]);
    var incrementVolume = function () { return setValue('volume', +selectedVolume + 10); };
    var decrementVolume = function () { return setValue('volume', +selectedVolume - 10); };
    return (_jsx("div", __assign({ className: "flex flex-col gap-6 justify-center w-full items-center px-12" }, { children: _jsx(Slider, { orientation: 'horizontal', name: "volume", className: "flex flex-row w-full gap-4", step: 10, valueLabelDisplay: isMobile ? 'on' : 'off', valueLabelFormat: function (value) { return "".concat(value / 10); }, BeforeIcon: _jsx(VolumeControl, __assign({ onClick: decrementVolume }, { children: _jsx(BsVolumeOff, { size: "2rem", color: theme.palette.primary.main }) })), AfterIcon: _jsx(VolumeControl, __assign({ onClick: incrementVolume }, { children: _jsx(BsVolumeUp, { size: "2rem", color: theme.palette.primary.main }) })) }) })));
}
var VolumeControl = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});
